import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CartLocations from './components/CartLocations';

const cartLocations = (props,{ t }) => (
  <Container>
    <CartLocations {...props} />
  </Container>
);

cartLocations.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(cartLocations);
